import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import * as Sentry from '@sentry/angular';

import { StaffSiteModule } from './staff-site.module';
import { environment } from '../../../environments/environment';

if (environment.production) {
  Sentry.init({
    dsn: environment.sentry_dsn,
    integrations: []
  });
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(StaffSiteModule)
  .catch(err => console.error(err));
